/**
 * Roles permitted to generate and export residential billing runs.
 * Shared by generate-run.ts and export-run.ts so the finance/admin gate stays
 * in one place (and matches the controlled RPCs' regulated_actor_context lists).
 *
 * REGION_FINANCE_OFFICER is intentionally excluded from permanent billing-run
 * mutation actions. The live generate/finalise/export RPC actor lists are
 * tenant finance/admin scoped; regional finance remains a broader finance
 * oversight/read cohort, not an operator for this workbench's controlled writes.
 */
export const FINANCE_BILLING_ROLES = ['SYSTEM_ADMIN', 'TENANT_ADMIN', 'FINANCE_OFFICER'] as const;

/** Readers of every residential billing step; writes remain finance-only. */
export const BILLING_READ_ROLES = [
  ...FINANCE_BILLING_ROLES,
  'FACILITY_MANAGER',
  'COMPLIANCE_OFFICER',
  'QUALITY_OFFICER',
] as const;

/** Oversight keeps billing summaries without resident-name paging. */
export function isBillingOversightReader(role: string | null | undefined): boolean {
  return ['COMPLIANCE_OFFICER', 'QUALITY_OFFICER'].includes(role ?? '');
}

export function canViewBillingResidentNames(role: string | null | undefined): boolean {
  return BILLING_READ_ROLES.some((reader) => reader === role) && !isBillingOversightReader(role);
}
